import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = ['coupon', 'inputContainer']

  handleInputFocused() {
    if (this.hasInputContainerTarget) {
      this.inputContainerTarget.classList.remove('invisible')
    }

    this.couponTargets.forEach((target) => target.classList.add('hidden'))
  }

  handleInputHidden() {
    // If there are no coupons there's no reason to hide the "add" button/icon
    if (this.hasCouponTarget) {
      if (this.hasInputContainerTarget) {
        this.inputContainerTarget.classList.add('invisible')
      }
      this.couponTargets.forEach((target) => target.classList.remove('hidden'))
    }
  }
}
